import type { RouteMeta, RouteRecordRaw } from "vue-router";

/**
 * Set the page navigation meta on a set of routes rendering the same page:
 * all the routes share the same page identity (the tab navigations between
 * them are ignored by the application back button) and the same back target.
 * @param pageKey Identity of the page, shared by all the routes.
 * @param backTo Back target of the application back button.
 * @param routes Routes rendering the same page.
 */
export function withPageNavigationMeta(
  pageKey: string,
  backTo: RouteMeta["backTo"],
  routes: RouteRecordRaw[],
): RouteRecordRaw[] {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      backTo,
      pageKey,
    },
  }));
}
